import React, { useState, useEffect, Fragment, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { FEATURE_RESTRICTION, IMAGES } from "../../../constants";
import { url } from "../../../config";
import Avatar from "react-avatar";
import { getProfileData, loadUser, logout } from "../../../actions/userActions";
import { useAlert } from "react-alert";
import { GetProductCount } from "../../../actions/productActions";
import { FormattedMessage, useIntl } from "react-intl";
import { getAllProductsFilter } from "../../../actions/productActions";
import { useLocation, useHistory } from "react-router";
import {
  decryptData,
  getLastURL,
  getSecondLastURL,
  numberWithCommas,
} from "../../../helper";
import { socket } from "../../../utils/socket";
import { Context } from "../../Wrapper";
import $ from "jquery";
import PaymentReNew from "../PaymentReNew";
import Rapaport from "../Rapaport";
import SubscriptionExpired from "../SubscriptionExpired";
import LogOutModal from "../../Modal/LogOutModal";
// const TurkeyFlagPng = require("../../../assets/images/turkey.png");
// const UKFlapPng = require("../../../assets/images/uk.png");
const GlobalPng = require("../../../assets/images/Group18403.png");
const languagePng = require("../../../assets/images/Path22170.png");
const heartPng = require("../../../assets/images/Path22161.png");
const messagePng = require("../../../assets/images/Path22160.png");


const ProtectedHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const context = useContext(Context);
  const pathname = getLastURL(location);
  const secpathname = getSecondLastURL(location);

  const dispatch = useDispatch();
  const alert = useAlert();
  const { user } = useSelector((state) => state.user);
  const { getProfile } = useSelector((state) => state.GetProfileWithBusiness);
  const { ProductCount } = useSelector((state) => state.ProductCount);
  const { category } = useSelector((state) => state.categories);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);

  const handleLogout = async () => {
    await dispatch(logout());
    localStorage.setItem('old_uuid' , localStorage.getItem('uuid'));
    localStorage.removeItem("isAuthenticated");
    sessionStorage.removeItem("user");
    localStorage.removeItem('address');
    localStorage.removeItem('user_data');
    sessionStorage.removeItem('socket_group_id')
    sessionStorage.removeItem('loading')
    alert.success("Logout successful");
    setTimeout(() => {
      window.location.href = url;
    }, 1500);
  };

  useEffect(() => {
    if (!ProductCount) {
      dispatch(GetProductCount());
    }

    if (sessionStorage.length >= 1) {
      try {
        socket?.emit("total_message_count", {});
      } catch (e) {
        console.error(e);
      }
    }

    try {
      socket?.on("total_message_count_response", (res) => {
        // const new_res = decryptData(res)
        const new_res = res
        if (new_res) {
          $(".messageCountGloble").html(new_res.total_unseen);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }, [ dispatch]); //ProductCount,


  const [productTypeSlug, setProductTypeSlug] = useState(pathname);
  const [search, setSearch] = useState();
  const [showLangList, setShowLangList] = useState(false);

  const handleCategoryChange = (event) => {
    setProductTypeSlug(event.target.value);
    // dispatch(getAllProductsFilter(productTypeSlug, { search: search }));
    localStorage.setItem(
      event.target.value + "filter",
      JSON.stringify({ search: search })
    );
    if (pathname == event?.target?.value && secpathname === "category") {
      dispatch(getAllProductsFilter(pathname, { search: search }, 0));
    } else {
      if (search && search?.length > 0) {
        history.push(
          `${url + "/category/" + event.target.value + "?search=" + search}`
        );
      } else {
        history.push(`${url + "/category/" + event.target.value}`);
      }
    }
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchFilter = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem(
        productTypeSlug + "filter",
        JSON.stringify({ search: search })
      );
      if (pathname == productTypeSlug && secpathname === "category") {
        dispatch(getAllProductsFilter(pathname, { search: search }, 0));
      } else {
        history.push(`${url + "/category/diamonds?search=" + search}`);
      }
    }
  };
  const handleAcendingFilter = (value) => {
    //setFilterDisplayName(displayname)
    $(".sort_by_list").css({
      display: "none",
    });
    context.selectLanguage(value);
    // dispatch(myProductFilterByAscending(category_slug, value, type))
  };

  const handleSelectCountry = (country) => {
    localStorage.removeItem(country);
    localStorage.setItem("country", country);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };


  const handleMessage = (e) => {
    e.preventDefault()
    if (Number(user?.is_valid_plan) === 1) {
      window.location.href = url + "/message"
    } else {
      alert.error(FEATURE_RESTRICTION.toLocaleLowerCase(), {
        timeout: 200000,
        containerStyle: { textTransform: "initial" }
      })
    }
  }




  return (
    <>
    <div className="pre-hader-bg">
      <div
        className="container-fluid"
        style={{ borderBottom: "solid 1px #E7E7E7" }}
      >
        <div className="row py-3 animated fadeInDownShort go">
          <div className="col-xs-12 col-md-5 col-lg-3">
            <div className="logo">
              <Link to={url + "/category/diamonds"} className="hidden-sm">
                <img src={IMAGES.WHITE_LOGO} alt="" />
              </Link>
            </div>
          </div>
          <div className="col-xs-12  col-md-7 col-lg-4">
            <div className="form-group mb-0 size">
              <select
                className="form-control top-cat-dropdown"
                onChange={handleCategoryChange}
                value={productTypeSlug}
              >
                {/* <FormattedMessage id="addsingleproduct.choose" defaultMessage="Choose">
                                            {(id) => <option value="">{id}</option>}
                                        </FormattedMessage> */}
                {category &&
                  category.categories &&
                  category.categories.map((category , i) => {
                    return (
                      <Fragment key={i}>
                        {category && (
                          <FormattedMessage
                            id={"category." + category.slug}
                            defaultMessage={category.name}
                          >
                            {(id) => (
                              <option
                                data-id={category.id}
                                value={category.slug}
                              >
                                {id}
                              </option>
                            )}
                          </FormattedMessage>
                        )}
                      </Fragment>
                    );
                  })}
              </select>
              <input
                type="text"
                className="form-control txt-box top-search"
                placeholder={useIntl().formatMessage({ id: "Search" })}
                onKeyPress={(e) => handleSearchFilter(e)}
                onChange={handleSearch}
              />
              <div className="input-search-icon">
                <span className="icon-search_1  input_icon"></span>
                <span>{(useIntl().formatMessage({ id: "SearchIcon" }) === 'Search') ? "Search" : "Arama" }</span>
              </div>
              {/* <img className="search-icon" src={IMAGES.searchIcon} /> */}
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 text-right mt-3 mt-lg-0 nav-right-box flex-wrap"  >
              {user   ? (
              <Link
                to={url + "/plan-details"}
                className="options op_btn mx-1 upgrade-btn"
                style={{color:'black' , backgroundColor:'orange'}}
              >
                <img className="bucket-img2" src={IMAGES.diamondHeader} alt="" />{" "}
              {/* Upgrade Plan */}
              <FormattedMessage
                    id="Upgrade Plan"
                    defaultMessage="Profile"
                  
                  />
              </Link>
            ) : ""}
            {user && Number(user?.role) === 2 && Number(user?.is_valid_plan) === 1 ? (
              <Link
                to={url + "/myproducts/diamonds"}
                className="options op_btn mx-1 amount-btn"
              >
                {" "}
                <img className="bucket-img" src={IMAGES.BOX_IMG2} alt="" />{" "}
                {ProductCount &&
                  "$" +
                  numberWithCommas(
                    parseFloat(ProductCount.productCount).toFixed(0)
                  )}
              </Link>
            ) : ""}
            {/* Language Select Dropdown  */}
            <span className="options filter_search_right">
              <div className=" search_cat_top w-100">
                <div className="sort_by_box m-0">
                  <p className="sort_b_h text-center lang_p justify-content-center m-0" onClick={() => { setShowLangList(!showLangList); }}>
                    <img
                      onClick={() => { setShowLangList(!showLangList); }}
                      src={languagePng}
                      alt="Country Flag"
                      className="cursor-pointer w-50"
                    />
                  </p>

                  {showLangList ? (
                    <div className="lang_list d-block">
                      <ul>
                        <li
                          className={context.locale === "tr" ? "active" : ""}
                          onClick={() => handleAcendingFilter("tr")}
                        >
                          <i className="fa fa-globe"></i> Turkish
                        </li>
                        <li
                          className={context.locale === "en" ? "active" : ""}
                          onClick={() => handleAcendingFilter("en")}
                        >
                          <i className="fa fa-globe"></i> English
                        </li>
                      </ul>
                    </div>
                  ) : ""}
                </div>
              </div>
            </span>

            {/* Country Select Dropdown  */}
            <span className="options filter_search_right">
              <div className=" search_cat_top">
                <div className="sort_by_box m-0">
                  <p
                    className="sort_b_h text-center lang_p m-0 justify-content-center"
                    onClick={() =>
                      setShowCountryDropdown(
                        showCountryDropdown === true ? false : true
                      )
                    }
                  >
                        <img
                          src={GlobalPng}
                          alt="Country Flag"
                          className="w-50"
                        />
                  </p>
                  <div
                    className={`country_list ${showCountryDropdown === false && "d-none"
                      }`}
                  >
                    {
                      <ul style={{ textAlign: "left" }}>
                        {/* <li className={localStorage.getItem("country") === 'turkey' && 'active'} onClick={() => handleSelectCountry('turkey')}><i className="fa fa-globe"></i> Turkey</li>
                        <li className={localStorage.getItem("country") === 'uk' && 'active'} onClick={() => handleSelectCountry('uk')} ><i className="fa fa-globe"></i>&nbsp; UK</li> */}

                        <li
                          className={`country-dropdown ${localStorage.getItem("country") === "turkey" &&
                            "active"
                            }`}
                          onClick={() => handleSelectCountry("turkey")}
                        >
                          <i className="fa fa-globe"></i> Turkey
                        </li>
                        <li
                          className={`country-dropdown ${localStorage.getItem("country") === "uk" && "active"
                            }`}
                          onClick={() => handleSelectCountry("uk")}
                        >
                          <i className="fa fa-globe"></i>&nbsp; UK
                        </li>
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </span>
            <span className="options ml-1">
              <a href="" onClick={(e) => handleMessage(e)}>
                <img className="w-50 option-x" src={messagePng} alt="" />
              </a>
              <span className="messageCountGloble">
                {ProductCount && ProductCount?.chatCount}
              </span>
            </span>
            <span className="options mx-1">
              <Link to={url + "/favorites/diamonds"}>
                <img className="w-50 option-x" src={heartPng} alt="" />
              </Link>
              <span>{ProductCount && ProductCount.favCount}</span>
            </span>
            {/* <Link to={url + "/profile"}><img src={IMAGES.PROFILE_IMG} className="u-img" alt="" /></Link> */}
            <span className="dropdown">
              <span
                className="dropdown-toggle"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                style={{ cursor: 'pointer' }}
              >
                <Avatar
                  round={true}
                  color={"#003B45"}
                  size="36"
                  name={getProfile?.user_business?.company_name ? getProfile?.user_business?.company_name : IMAGES?.PROFILE_IMG}
                  src={
                    user?.profile_picture_full_thumb ?
                      user?.profile_picture_full_thumb :
                      IMAGES?.PROFILE1
                  }
                  className={user?.profile_picture_full_thumb ? 'u-img user-img-area user-img-area-1' : 'u-img user-img-area user-img-area-2 option-x'}
                />
              </span>
              <span
                className="dropdown-menu profile-drop-menu p-2"
                aria-labelledby="dropdownMenuButton"
              >
                <Link
                  className="dropdown-item font-weight-bold"
                  to={url + "/profile"}
                >
                  <FormattedMessage
                    id="main.header.myprofile"
                    defaultMessage="Profile"
                  />
                </Link>
                <span
                  className="dropdown-item font-weight-bold"
                  onClick={handleLogout}
                >
                  <FormattedMessage
                    id="main.header.logout"
                    defaultMessage="Logout"
                  />
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    {(user?.is_payment_failed_retry == "1" && user?.is_payment_reminder == '0') ? 
    <PaymentReNew data={user}/>
    : null}
    {(user?.is_payment_failed_retry == "1" && ( user?.is_payment_failed_retry == "1" && user?.is_payment_reminder == '1' ) ) ? 
    <PaymentReNew data={user}/>
    : null}
    {(user?.is_payment_reminder == '1' && user?.is_payment_failed_retry == "0") ?  
    <Rapaport data={user} />
    :null}
    {user?.is_payment_reminder == '-1' ?  
    <SubscriptionExpired data={user} />
    :null}
    </>
  );
};

export default ProtectedHeader;
